import { all } from 'redux-saga/effects';
import { authSaga } from '../data/auth';
import { dashboardSaga } from '../data/dashboard';

function* mySaga() {
  yield all([
    authSaga(),
    dashboardSaga()
  ])
}

export default mySaga;



// WEBPACK FOOTER //
// ./src/store/sagas.js